export default `
mutation RESET_PASSWORD_MUTATION ($email: String!) {
  requestPasswordResetEmail(
    email: $email
  )
}`
